import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  gap: ${({ theme }) => theme.spacing[2]}px;
`;
